import { z } from "zod";

export const DomainSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string(),
});

export const ProjectSchema = z.object({
  id: z.number(),
  name: z.string(),
  primary_domain_id: z.number().nullable(),
  region: z.string(),
});

export const ObjectTypeSchema = z.object({
  id: z.number(),
  en_name: z.string(),
  se_name: z.string(),
  color: z.string(),
  issue: z.boolean(),
  skyqraft_only: z.boolean(),
  is_sensitive: z.boolean(),
});

export const WorkflowStatusSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type Domain = z.infer<typeof DomainSchema>;
export type Project = z.infer<typeof ProjectSchema>;
export type ObjectType = z.infer<typeof ObjectTypeSchema>;
export type WorkflowStatus = z.infer<typeof WorkflowStatusSchema>;
